import { computed, inject, Injectable } from '@angular/core';
import { SuperOffersService } from '../../../api/api-nmviajes/services/super-offers.service';
import { TokenService } from '../../../api/api-motor-vuelos';
import { HomeState } from './home.state';
import { enrichFlightOfferWithExchange } from '../utils/sections.util';
import { FLIGHT_OFFER_CATEGORY, FLIGHT_OFFER_MAX_ITEMS } from '../constants/offers.constant';
import { of } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { Offer } from '../../../shared/models/offers.model';

@Injectable()
export class FlightOffersFacade {
  private readonly api = inject(SuperOffersService);
  private readonly state = inject(HomeState);
  private readonly tokenService = inject(TokenService);

  readonly isLoading = this.state.isOffersLoading;

  private readonly enrichedOffers = computed(() => {
    const offers = this.state.flightOffers();
    const exchangeRate = this.tokenService.exchangeRate();

    if (!exchangeRate || offers.length === 0) return offers;
    return offers.map((offer: any) => enrichFlightOfferWithExchange(offer, exchangeRate));
  });

  readonly domesticOffers = computed(() =>
    this.enrichedOffers()
      .filter((o) => o.type === FLIGHT_OFFER_CATEGORY.Domestic)
      .slice(0, FLIGHT_OFFER_MAX_ITEMS)
  );

  readonly internationalOffers = computed(() =>
    this.enrichedOffers()
      .filter((o) => o.type === FLIGHT_OFFER_CATEGORY.International)
      .slice(0, FLIGHT_OFFER_MAX_ITEMS)
  );

  fetchOffers(): void {
    if (this.state.flightOffers().length > 0) return;

    this.state.setOffersLoading(true);

    this.api
      .fetchTopFlightOffers()
      .pipe(
        catchError(() => of([] as Offer[])),
        finalize(() => this.state.setOffersLoading(false))
      )
      .subscribe((offers) => this.state.setFlightOffers(offers));
  }
}
